import { render, staticRenderFns } from "./Interlocuteur.vue?vue&type=template&id=40dd533d&scoped=true&"
import script from "./Interlocuteur.vue?vue&type=script&lang=js&"
export * from "./Interlocuteur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dd533d",
  null
  
)

export default component.exports